import React from 'react';

export const errorsFormatter = cell => {
  const errorMessages = (cell ?? []).reduce((acc, error) => {
    const { column, level, message } = error;
    const errorMessage = `[${level}] ${column}: ${message}`;
    return [...acc, errorMessage];
  }, []);
  return errorMessages.length > 0
    ? errorMessages.map(errorMessage => <div>{errorMessage}</div>)
    : '-';
};

export default errorsFormatter;
